import confetti from 'canvas-confetti';
import { useTheme } from '@mui/material';
import { useCallback, useRef } from 'react';

// Create a confetti instance without Web Worker to avoid CSP blob: restrictions.
// This runs on the main thread but has negligible performance impact for short animations.
const confettiNoWorker = confetti.create(undefined, {
  useWorker: false,
  resize: true
});

export const useConfetti = () => {
  const theme = useTheme();
  const animationFrameRef = useRef<number | null>(null);

  const triggerConfetti = useCallback(() => {
    const duration = 3000;
    const end = Date.now() + duration;

    const colors = [
      theme.palette.primary.main,
      theme.palette.primary.light,
      theme.palette.secondary.main,
      theme.palette.success.main
    ];

    const frame = () => {
      confettiNoWorker({
        particleCount: 4,
        angle: 60,
        spread: 55,
        origin: { x: 0, y: 0.6 },
        colors
      });
      confettiNoWorker({
        particleCount: 4,
        angle: 120,
        spread: 55,
        origin: { x: 1, y: 0.6 },
        colors
      });

      if (Date.now() < end) {
        animationFrameRef.current = requestAnimationFrame(frame);
      }
    };

    frame();
  }, [theme.palette]);

  return { triggerConfetti };
};
